export function extractServerError(
    errorObj: any,
    defaultMsg = 'Something went wrong. Please try again.',
): { description: string; code?: string } {
    if (errorObj?.error?.primary?.description) {
        return {
            description: errorObj.error.primary.description,
            code: errorObj.error.primary.code,
        };
    }

    if (
        errorObj?.error?.supplementary &&
        Array.isArray(errorObj.error.supplementary) &&
        errorObj.error.supplementary[0]?.description
    ) {
        return {
            description: errorObj.error.supplementary[0].description,
            code: errorObj.error.supplementary[0].code,
        };
    }

    if (typeof errorObj?.message === 'string') {
        return { description: errorObj.message };
    }

    // Fallback
    return { description: defaultMsg };
}
